export const STATUS_CERTIFICATE = {
  request: "SOLICITUD",
  request_cert: "REVISION",
  generate: "GENERAR",
  current: "VIGENTE",
  revoque: "REVOCADO",
  expire: "EXPIRADO",
  request_revoque: "SOLICITUD_DE_REVOCACION",
  certificate_another_device: "CERTIFICADO_EN_OTRO_DISPOSITIVO",
  sign_pending: "PENDIENTE_POR_FIRMAR",
};

export const PARSE_STATUS = {
  [STATUS_CERTIFICATE.certificate_another_device]: {
    text: "Certificado generado en otro dispositivo",
    descriptionText:
      "Su certificado fue generado en otro equipo. Para usarlo aquí, debe migrar el certificado o solicitar la revocación del anterior para generar uno nuevo.",
  },
  [STATUS_CERTIFICATE.request_cert]: {
    text: "En revisión",
    descriptionText:
      "La información y documentos enviados están siendo certificados por la Autoridad de Certificación para confirmar su validez.",
  },
  [STATUS_CERTIFICATE.request]: {
    text: "Por verificar",
    descriptionText:
      "La información y documentos enviados están siendo revisados por la Autoridad de Registro.",
  },
  [STATUS_CERTIFICATE.generate]: {
    text: "Por generar",
    descriptionText:
      "Tu solicitud fue aprobada. Solo falta que generes tu certificado para comenzar a usarlo.",
  },
  [STATUS_CERTIFICATE.current]: {
    text: "Verificado",
    descriptionText: undefined,
  },
  [STATUS_CERTIFICATE.expire]: "Certificado expirado.",
  [STATUS_CERTIFICATE.request_revoque]: {
    text: "Por revocar",
    descriptionText:
      "Recibimos tu solicitud de revocación y estamos procesándola. El certificado dejará de ser válido una vez finalice el trámite.",
  },
  [STATUS_CERTIFICATE.revoque]: {
    text: "Revocado",
    descriptionText:
      "Este certificado ha sido revocado. Debes solicitar uno nuevo.",
  },
};

export const VERIFICATION_STATUS = {
  IN_REGISTER: 0,
  APPROVED: 1,
};

export const INTEGRATION_TYPE = {
  ONBOARDING: "ONBOARDING",
  ONPREMISE: "ONPREMISE",
};
